import { CurrentTournamentMatchGameState } from 'modules/tournaments/store/current-tournament-match-game/interfaces';

export const clearTournamentMatchGameReducer = (state: CurrentTournamentMatchGameState): void => {
  state.entity = {};
};
